module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list disk-index"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("网盘")]), _vm._v(" "), _vm._l((_vm.breadcrumb), function(item, index) {
    return _c('Breadcrumb-item', {
      key: item.id
    }, [(index < _vm.breadcrumb.length - 1) ? _c('a', {
      on: {
        "click": function($event) {
          return _vm.jumpTo(index)
        }
      }
    }, [_vm._v(_vm._s(item.name))]) : _c('span', [_vm._v(_vm._s(item.name))])])
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "disk-body"
  }, [_c('div', {
    staticClass: "disk-side"
  }, [_vm._l((_vm.mainSpaces), function(sp) {
    return _c('div', {
      key: sp.key,
      class: ['disk-space-item', {
        on: _vm.activeSpace && _vm.activeSpace.key === sp.key
      }],
      on: {
        "click": function($event) {
          return _vm.enterSpace(sp)
        }
      }
    }, [_c('Icon', {
      attrs: {
        "type": sp.key === 'recycle' ? 'ios-trash' : 'folder'
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.spaceLabel(sp)))])], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "disk-side-section"
  }, [_c('div', {
    staticClass: "disk-side-title"
  }, [_c('span', [_vm._v("我的群")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.openCreateGroup.apply(null, arguments)
      }
    }
  }, [_vm._v("新建群")])]), _vm._v(" "), _c('div', {
    staticClass: "disk-group-search"
  }, [_c('Input', {
    attrs: {
      "size": "small",
      "clearable": "",
      "placeholder": "搜索群名称",
      "icon": "ios-search"
    },
    model: {
      value: (_vm.groupKeyword),
      callback: function($$v) {
        _vm.groupKeyword = $$v
      },
      expression: "groupKeyword"
    }
  })], 1), _vm._v(" "), (!_vm.groupSpaces.length) ? _c('div', {
    staticClass: "disk-side-empty"
  }, [_vm._v("暂无群")]) : (!_vm.filteredGroupSpaces.length) ? _c('div', {
    staticClass: "disk-side-empty"
  }, [_vm._v("没有匹配的群")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.filteredGroupSpaces), function(sp) {
    return _c('div', {
      key: sp.key,
      class: ['disk-space-item', 'disk-group-item', {
        on: _vm.activeSpace && _vm.activeSpace.key === sp.key
      }],
      on: {
        "click": function($event) {
          return _vm.enterSpace(sp)
        }
      }
    }, [_c('Icon', {
      attrs: {
        "type": "ios-people"
      }
    }), _vm._v(" "), _c('span', {
      attrs: {
        "title": sp.node.name
      }
    }, [_vm._v(_vm._s(sp.node.name))])], 1)
  })], 2)], 2), _vm._v(" "), _c('div', {
    staticClass: "disk-main"
  }, [(_vm.inGroupSpace && _vm.activeGroup) ? _c('div', {
    staticClass: "disk-group-header"
  }, [_c('div', {
    staticClass: "disk-group-meta"
  }, [_c('strong', [_vm._v(_vm._s(_vm.activeGroup.name))]), _vm._v(" "), _c('span', [_vm._v("成员 " + _vm._s(_vm.activeGroup.memberCount || 0) + " 人")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.roleText(_vm.activeGroup.myRole)))]), _vm._v(" "), _c('Button', {
    staticClass: "disk-group-member-btn",
    attrs: {
      "size": "small",
      "type": "text",
      "icon": "ios-time"
    },
    on: {
      "click": _vm.openActivityPanel
    }
  }, [_vm._v("活动")]), _vm._v(" "), (_vm.isGroupManager) ? _c('Button', {
    staticClass: "disk-group-member-btn",
    attrs: {
      "size": "small",
      "type": "text",
      "icon": "ios-people"
    },
    on: {
      "click": _vm.openMemberManage
    }
  }, [_vm._v("成员管理")]) : _c('Button', {
    staticClass: "disk-group-member-btn",
    attrs: {
      "size": "small",
      "type": "text"
    },
    on: {
      "click": _vm.leaveGroup
    }
  }, [_vm._v("退群")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.inGroupSpace && _vm.activeGroup && Number(_vm.activeGroup.id) === 1) ? _c('disk-group-nav', {
    attrs: {
      "group-id": _vm.activeGroup.id,
      "root-node-id": _vm.activeGroup.rootNodeId || (_vm.activeSpace && _vm.activeSpace.node && _vm.activeSpace.node.id),
      "current-folder-id": _vm.currentFolder && _vm.currentFolder.id
    },
    on: {
      "open-target": _vm.onNavOpenTarget
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.inRecycle),
      expression: "!inRecycle"
    }],
    staticClass: "disk-toolbar"
  }, [_c('input', {
    ref: "fileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "multiple": ""
    },
    on: {
      "change": _vm.onFilePicked
    }
  }), _vm._v(" "), _c('input', {
    ref: "folderInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "multiple": "",
      "webkitdirectory": ""
    },
    on: {
      "change": _vm.onFilePicked
    }
  }), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "icon": "ios-cloud-upload",
      "disabled": !_vm.canUpload
    },
    on: {
      "click": _vm.chooseUpload
    }
  }, [_vm._v("上传")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "icon": "ios-folder",
      "disabled": !_vm.canUpload
    },
    on: {
      "click": _vm.openMkdir
    }
  }, [_vm._v("新建文件夹")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "icon": "ios-download",
      "disabled": !_vm.canDownload
    },
    on: {
      "click": _vm.downloadSelected
    }
  }, [_vm._v("下载")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "icon": "ios-redo",
      "disabled": !_vm.canMove
    },
    on: {
      "click": _vm.openMoveSelected
    }
  }, [_vm._v("移动")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "icon": "share",
      "disabled": !_vm.canShare
    },
    on: {
      "click": function($event) {
        return _vm.openShare()
      }
    }
  }, [_vm._v("分享")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "icon": "key",
      "disabled": !_vm.canAcl
    },
    on: {
      "click": function($event) {
        return _vm.openAcl()
      }
    }
  }, [_vm._v("授权")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "icon": "ios-trash",
      "disabled": !_vm.canDelete
    },
    on: {
      "click": _vm.deleteSelected
    }
  }, [_vm._v("删除")]), _vm._v(" "), _c('div', {
    staticClass: "disk-search"
  }, [_c('Input', {
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "placeholder": "搜索当前目录及子目录",
      "clearable": ""
    },
    on: {
      "on-enter": _vm.search
    },
    model: {
      value: (_vm.keyword),
      callback: function($$v) {
        _vm.keyword = $$v
      },
      expression: "keyword"
    }
  }), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "icon": "ios-search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")])], 1)], 1), _vm._v(" "), _c('Table', {
    class: _vm.inRecycle ? '' : 'disk-file-table',
    attrs: {
      "border": "",
      "highlight-row": "",
      "columns": _vm.displayColumns,
      "data": _vm.list,
      "loading": _vm.loading
    },
    on: {
      "on-selection-change": _vm.onSelectionChange,
      "on-current-change": _vm.onCurrentChange
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "disk-tip"
  }, [_vm._v(_vm._s(_vm.inRecycle ? '删除只移入回收站，云上的文件仍保留。这里可以恢复。' : '点文件名直接预览。可勾选多行后批量下载、移动、分享、授权、删除。名称后面的「操作」可打开、下载、预览、重命名、移动、复制、分享、授权、删除'))])], 1)]), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "新建文件夹",
      "width": "420",
      "mask-closable": false
    },
    model: {
      value: (_vm.showMkdirModal),
      callback: function($$v) {
        _vm.showMkdirModal = $$v
      },
      expression: "showMkdirModal"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入文件夹名称",
      "maxlength": 255
    },
    on: {
      "on-enter": _vm.onMkdir
    },
    model: {
      value: (_vm.mkdirName),
      callback: function($$v) {
        _vm.mkdirName = $$v
      },
      expression: "mkdirName"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.showMkdirModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.mkdirLoading
    },
    on: {
      "click": _vm.onMkdir
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "重命名",
      "width": "420",
      "mask-closable": false
    },
    model: {
      value: (_vm.showRenameModal),
      callback: function($$v) {
        _vm.showRenameModal = $$v
      },
      expression: "showRenameModal"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入新名称",
      "maxlength": 255
    },
    on: {
      "on-enter": _vm.onRename
    },
    model: {
      value: (_vm.renameName),
      callback: function($$v) {
        _vm.renameName = $$v
      },
      expression: "renameName"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.showRenameModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.renameLoading
    },
    on: {
      "click": _vm.onRename
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": _vm.pickerMode === 'copy' ? '复制' : '移动',
      "width": "520",
      "mask-closable": false
    },
    model: {
      value: (_vm.showMoveModal),
      callback: function($$v) {
        _vm.showMoveModal = $$v
      },
      expression: "showMoveModal"
    }
  }, [_c('div', {
    staticClass: "disk-modal-node"
  }, [_vm._v(_vm._s(_vm.moveTitle))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "8px"
    }
  }, _vm._l((_vm.moveSpaces), function(sp) {
    return _c('Button', {
      key: sp.key,
      staticStyle: {
        "margin-right": "8px"
      },
      attrs: {
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.switchMoveSpace(sp)
        }
      }
    }, [_vm._v(_vm._s(sp.node.name))])
  }), 1), _vm._v(" "), _c('Breadcrumb', {
    staticStyle: {
      "margin-bottom": "8px"
    }
  }, _vm._l((_vm.moveCrumbs), function(item, index) {
    return _c('Breadcrumb-item', {
      key: item.id
    }, [(index < _vm.moveCrumbs.length - 1) ? _c('a', {
      on: {
        "click": function($event) {
          return _vm.jumpMove(index)
        }
      }
    }, [_vm._v(_vm._s(item.name))]) : _c('span', [_vm._v(_vm._s(item.name))])])
  }), 1), _vm._v(" "), (_vm.moveFolderLoading) ? _c('div', {
    staticClass: "disk-tip"
  }, [_vm._v("加载中...")]) : (!_vm.moveFolders.length) ? _c('div', {
    staticClass: "disk-tip"
  }, [_vm._v(_vm._s(_vm.pickerMode === 'copy' ? '该目录下没有文件夹。可以直接复制到此处。' : '该目录下没有文件夹。可以直接移动到此处。'))]) : _c('div', {
    staticClass: "disk-move-folders"
  }, _vm._l((_vm.moveFolders), function(folder) {
    return _c('div', {
      key: folder.id,
      staticClass: "disk-move-folder",
      on: {
        "click": function($event) {
          return _vm.enterMoveFolder(folder)
        }
      }
    }, [_c('Icon', {
      attrs: {
        "type": "folder"
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(folder.name))])], 1)
  }), 0), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.showMoveModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.moveSaving,
      "disabled": _vm.moveHereDisabled
    },
    on: {
      "click": _vm.confirmMove
    }
  }, [_vm._v(_vm._s(_vm.pickerMode === 'copy' ? '复制到此处' : '移动到此处'))])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": '预览 - ' + _vm.previewName,
      "width": "960"
    },
    on: {
      "on-visible-change": _vm.onPreviewVisible
    },
    model: {
      value: (_vm.showPreviewModal),
      callback: function($$v) {
        _vm.showPreviewModal = $$v
      },
      expression: "showPreviewModal"
    }
  }, [_c('div', {
    staticClass: "disk-preview",
    class: {
      'disk-preview-center': _vm.centerPreview
    }
  }, [(_vm.previewLoading) ? _c('div', {
    staticClass: "disk-preview-tip"
  }, [_vm._v("加载中...")]) : (_vm.previewError) ? _c('div', {
    staticClass: "disk-preview-tip"
  }, [_vm._v(_vm._s(_vm.previewError))]) : (_vm.previewType === 'image') ? _c('img', {
    staticClass: "disk-preview-image",
    attrs: {
      "src": _vm.previewUrl
    }
  }) : (_vm.previewType === 'pdf') ? _c('iframe', {
    staticClass: "disk-preview-frame",
    attrs: {
      "src": _vm.previewBlobUrl
    }
  }) : (_vm.previewType === 'video') ? [_c('video', {
    ref: "previewVideo",
    staticClass: "disk-preview-media",
    attrs: {
      "src": _vm.previewUrl,
      "controls": ""
    },
    on: {
      "error": _vm.onMediaError
    }
  }), _vm._v(" "), (_vm.mediaError) ? _c('div', {
    staticClass: "disk-preview-tip"
  }, [_vm._v("该格式无法预览，请下载")]) : _vm._e()] : (_vm.previewType === 'audio') ? [_c('audio', {
    ref: "previewAudio",
    attrs: {
      "src": _vm.previewUrl,
      "controls": ""
    },
    on: {
      "error": _vm.onMediaError
    }
  }), _vm._v(" "), (_vm.mediaError) ? _c('div', {
    staticClass: "disk-preview-tip"
  }, [_vm._v("该格式无法预览，请下载")]) : _vm._e()] : (_vm.previewType === 'office' && _vm.previewEngine === 'aliyun') ? [_c('div', {
    ref: "aliyunOffice",
    staticClass: "disk-preview-frame"
  })] : (_vm.previewType === 'office') ? [_c('iframe', {
    staticClass: "disk-preview-frame",
    attrs: {
      "src": _vm.officeUrl
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "disk-preview-hint"
  }, [_vm._v("若无法打开，请下载后查看")])] : (_vm.previewType === 'csv') ? [(_vm.previewEmpty) ? _c('div', {
    staticClass: "disk-preview-tip"
  }, [_vm._v("没有可预览的内容")]) : _c('div', {
    staticClass: "disk-preview-table-wrap"
  }, [_c('table', {
    staticClass: "disk-preview-table"
  }, [_c('tbody', _vm._l((_vm.previewRows), function(line, lineIndex) {
    return _c('tr', {
      key: lineIndex
    }, _vm._l((line), function(cell, cellIndex) {
      return _c('td', {
        key: cellIndex,
        class: {
          'disk-preview-th': lineIndex === 0
        }
      }, [_vm._v(_vm._s(cell))])
    }), 0)
  }), 0)])])] : (_vm.previewType === 'markdown') ? _c('div', {
    staticClass: "disk-preview-markdown",
    domProps: {
      "innerHTML": _vm._s(_vm.previewHtml)
    }
  }) : (_vm.previewType === 'json') ? [(_vm.jsonError) ? _c('div', {
    staticClass: "disk-preview-hint"
  }, [_vm._v("不是合法 JSON")]) : _vm._e(), _vm._v(" "), _c('pre', {
    staticClass: "disk-preview-pre"
  }, [_vm._v(_vm._s(_vm.previewText))])] : (_vm.previewType === 'text') ? _c('pre', {
    staticClass: "disk-preview-pre"
  }, [_vm._v(_vm._s(_vm.previewText))]) : _c('div', {
    staticClass: "disk-preview-tip"
  }, [_vm._v("该格式无法预览，请下载")])], 2), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "icon": "ios-download"
    },
    on: {
      "click": function($event) {
        return _vm.download(_vm.previewDownloadId)
      }
    }
  }, [_vm._v("下载")])], 1)]), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "授权",
      "width": "860"
    },
    model: {
      value: (_vm.showAclModal),
      callback: function($$v) {
        _vm.showAclModal = $$v
      },
      expression: "showAclModal"
    }
  }, [_c('div', {
    staticClass: "disk-modal-node"
  }, [_vm._v(_vm._s(_vm.aclTitle))]), _vm._v(" "), _c('div', {
    staticClass: "disk-acl-form"
  }, [_c('Select', {
    staticStyle: {
      "width": "110px"
    },
    on: {
      "on-change": _vm.onSubjectTypeChange
    },
    model: {
      value: (_vm.aclForm.subjectType),
      callback: function($$v) {
        _vm.$set(_vm.aclForm, "subjectType", $$v)
      },
      expression: "aclForm.subjectType"
    }
  }, [_c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("员工")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("权限组")])], 1), _vm._v(" "), (_vm.aclForm.subjectType === 1) ? [_c('Select', {
    key: 'acl-users-' + _vm.adminUserSelectKey,
    staticStyle: {
      "width": "280px",
      "margin-left": "8px"
    },
    attrs: {
      "multiple": "",
      "filterable": "",
      "transfer": "",
      "loading": _vm.adminUserLoading,
      "disabled": _vm.adminUserLoading,
      "placeholder": "选择员工"
    },
    model: {
      value: (_vm.aclForm.subjectIds),
      callback: function($$v) {
        _vm.$set(_vm.aclForm, "subjectIds", $$v)
      },
      expression: "aclForm.subjectIds"
    }
  }, _vm._l((_vm.aclAdminUsers), function(user) {
    return _c('Option', {
      key: user.id,
      attrs: {
        "value": user.id,
        "label": _vm.userLabel(user)
      }
    }, [_vm._v("\n            " + _vm._s(_vm.userLabel(user)) + "\n          ")])
  }), 1), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "disabled": _vm.adminUserLoading || !_vm.aclAdminUsers.length
    },
    on: {
      "click": _vm.selectAllUsers
    }
  }, [_vm._v("全选全部员工")])] : [_c('Select', {
    key: 'acl-groups-' + _vm.adminGroupSelectKey,
    staticStyle: {
      "width": "280px",
      "margin-left": "8px"
    },
    attrs: {
      "multiple": "",
      "filterable": "",
      "transfer": "",
      "loading": _vm.adminGroupLoading,
      "disabled": _vm.adminGroupLoading,
      "placeholder": "选择权限组"
    },
    model: {
      value: (_vm.aclForm.subjectIds),
      callback: function($$v) {
        _vm.$set(_vm.aclForm, "subjectIds", $$v)
      },
      expression: "aclForm.subjectIds"
    }
  }, _vm._l((_vm.adminGroups), function(group) {
    return _c('Option', {
      key: group.id,
      attrs: {
        "value": group.id,
        "label": group.title
      }
    }, [_vm._v(_vm._s(group.title))])
  }), 1), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "disabled": _vm.adminGroupLoading || !_vm.adminGroups.length
    },
    on: {
      "click": _vm.selectAllGroups
    }
  }, [_vm._v("全选全部权限组")])], _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.aclSaving
    },
    on: {
      "click": _vm.saveAcl
    }
  }, [_vm._v("保存")])], 2), _vm._v(" "), _c('div', {
    staticClass: "disk-acl-perm"
  }, [_c('span', {
    staticClass: "disk-acl-perm-label"
  }, [_vm._v("权限")]), _vm._v(" "), _c('CheckboxGroup', {
    model: {
      value: (_vm.aclForm.permBits),
      callback: function($$v) {
        _vm.$set(_vm.aclForm, "permBits", $$v)
      },
      expression: "aclForm.permBits"
    }
  }, _vm._l((_vm.permOptions), function(item) {
    return _c('Checkbox', {
      key: item.value,
      attrs: {
        "label": item.value
      }
    }, [_vm._v(_vm._s(item.label))])
  }), 1)], 1), _vm._v(" "), (_vm.aclNodes.length <= 1) ? _c('Table', {
    attrs: {
      "border": "",
      "columns": _vm.aclColumns,
      "data": _vm.aclList,
      "loading": _vm.aclLoading
    }
  }) : _c('div', {
    staticClass: "disk-tip"
  }, [_vm._v("保存后，同样的授权会写到每一个选中项。")])], 1), _vm._v(" "), _c('Modal', {
    staticClass: "disk-share-modal",
    attrs: {
      "title": "分享",
      "width": "1100"
    },
    model: {
      value: (_vm.showShareModal),
      callback: function($$v) {
        _vm.showShareModal = $$v
      },
      expression: "showShareModal"
    }
  }, [_c('div', {
    staticClass: "disk-modal-node"
  }, [_vm._v(_vm._s(_vm.shareTitle))]), _vm._v(" "), _c('Form', {
    attrs: {
      "label-width": 90
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "有效期"
    }
  }, [_c('RadioGroup', {
    model: {
      value: (_vm.shareForm.expireType),
      callback: function($$v) {
        _vm.$set(_vm.shareForm, "expireType", $$v)
      },
      expression: "shareForm.expireType"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("1天")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "7"
    }
  }, [_vm._v("7天")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "30"
    }
  }, [_vm._v("30天")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "custom"
    }
  }, [_vm._v("自定义时间")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "forever"
    }
  }, [_vm._v("永久")])], 1)], 1), _vm._v(" "), (_vm.shareForm.expireType === 'custom') ? _c('FormItem', {
    attrs: {
      "label": "到期时间"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm:ss",
      "placeholder": "请选择到期时间",
      "value": _vm.shareForm.customExpireDate
    },
    on: {
      "on-change": _vm.onCustomExpire
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "提取码"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "maxlength": 4,
      "placeholder": "4位提取码，可空"
    },
    model: {
      value: (_vm.shareForm.extractCode),
      callback: function($$v) {
        _vm.$set(_vm.shareForm, "extractCode", $$v)
      },
      expression: "shareForm.extractCode"
    }
  })], 1)], 1), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.shareSaving
    },
    on: {
      "click": _vm.createShare
    }
  }, [_vm._v("生成链接")]), _vm._v(" "), _c('Table', {
    staticStyle: {
      "margin-top": "12px"
    },
    attrs: {
      "border": "",
      "columns": _vm.shareColumns,
      "data": _vm.shareList
    }
  })], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "详细记录",
      "width": "720"
    },
    model: {
      value: (_vm.showShareLogModal),
      callback: function($$v) {
        _vm.showShareLogModal = $$v
      },
      expression: "showShareLogModal"
    }
  }, [_c('Table', {
    attrs: {
      "border": "",
      "columns": _vm.shareLogColumns,
      "data": _vm.shareLogList,
      "loading": _vm.shareLogLoading,
      "no-data-text": "还没有预览或下载"
    }
  })], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "上传文件",
      "width": "860",
      "mask-closable": false
    },
    model: {
      value: (_vm.showUploadModal),
      callback: function($$v) {
        _vm.showUploadModal = $$v
      },
      expression: "showUploadModal"
    }
  }, [_c('div', {
    staticClass: "disk-upload-target"
  }, [_vm._v("上传到：" + _vm._s(_vm.currentFolder ? _vm.currentFolder.name : '当前目录'))]), _vm._v(" "), _c('div', {
    staticClass: "disk-upload-target"
  }, [_c('span', [_vm._v("同名是否覆盖")]), _vm._v(" "), _c('i-switch', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "size": "large"
    },
    model: {
      value: (_vm.overwriteSame),
      callback: function($$v) {
        _vm.overwriteSame = $$v
      },
      expression: "overwriteSame"
    }
  }, [_c('span', {
    attrs: {
      "slot": "open"
    },
    slot: "open"
  }, [_vm._v("是")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "close"
    },
    slot: "close"
  }, [_vm._v("否")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "disk-upload-label"
  }, [_vm._v("待上传文件")]), _vm._v(" "), _c('div', {
    staticClass: "disk-drop",
    on: {
      "dragover": function($event) {
        $event.preventDefault();
      },
      "drop": function($event) {
        $event.preventDefault();
        return _vm.onDropFiles.apply(null, arguments)
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-cloud-upload",
      "size": "36"
    }
  }), _vm._v(" "), _c('p', [_vm._v("将目录或多个文件拖拽到此进行扫描")]), _vm._v(" "), _c('div', [_c('Button', {
    on: {
      "click": _vm.pickFiles
    }
  }, [_vm._v("扫描文件")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    on: {
      "click": _vm.pickFolder
    }
  }, [_vm._v("扫描文件夹")])], 1), _vm._v(" "), _c('p', {
    staticClass: "disk-tip"
  }, [_vm._v("文件命名规范：1.使用 UTF-8 编码 2.区分大小写 3.长度必须在 1~1023 字节之间 4. 不能以 / 或者 \\ 字符开头")]), _vm._v(" "), _c('p', {
    staticClass: "disk-tip"
  }, [_vm._v("文件上传提示：待上传列表最多允许添加 10000 个文件，超出部分被丢弃，如果要完整上传，请将文件打包成 Zip 包，上传后解压。")]), _vm._v(" "), _c('p', {
    staticClass: "disk-tip"
  }, [_vm._v("扫描只加入待上传列表，不会上传。点下方「上传文件」后才开始。同名是否覆盖默认关闭。关闭时同名文件会另存为「主名.1.0.后缀」，已有 1.x 则次版本加 1。打开后原文件会被彻底删除，不进回收站，再用同名上传新文件。同名文件夹仍直接使用。")])], 1), _vm._v(" "), (_vm.scanning) ? _c('p', {
    staticClass: "disk-tip"
  }, [_vm._v("正在扫描，已读取 " + _vm._s(_vm.scanCount) + " 个文件…")]) : _vm._e(), _vm._v(" "), _c('Table', {
    staticStyle: {
      "margin-top": "12px"
    },
    attrs: {
      "border": "",
      "columns": _vm.uploadColumns,
      "data": _vm.uploadPageRows,
      "no-data-text": "没有文件或文件夹"
    }
  }), _vm._v(" "), (_vm.uploadTotal) ? _c('div', {
    staticClass: "disk-upload-page"
  }, [_c('span', [_vm._v("共 " + _vm._s(_vm.uploadTotal) + " 个")]), _vm._v(" "), _c('Page', {
    attrs: {
      "total": _vm.uploadTotal,
      "page-size": _vm.uploadPageSize,
      "current": _vm.uploadPage,
      "size": "small"
    },
    on: {
      "on-change": _vm.onUploadPage
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.canBeginUpload,
      "loading": _vm.uploading
    },
    on: {
      "click": _vm.beginUpload
    }
  }, [_vm._v("上传文件")]), _vm._v(" "), _c('Button', {
    on: {
      "click": function($event) {
        _vm.showUploadModal = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1), _vm._v(" "), (_vm.activityPanelOpen) ? _c('div', {
    staticClass: "disk-activity-drawer"
  }, [_c('div', {
    staticClass: "disk-activity-head"
  }, [_c('span', [_vm._v("群动态")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.activityPanelOpen = false
      }
    }
  }, [_vm._v("收起")])]), _vm._v(" "), (_vm.activityLoading && !_vm.activityGroups.length) ? _c('div', {
    staticClass: "disk-activity-empty"
  }, [_vm._v("加载中…")]) : (!_vm.activityGroups.length) ? _c('div', {
    staticClass: "disk-activity-empty"
  }, [_vm._v("暂无群动态")]) : _c('div', {
    staticClass: "disk-activity-body",
    on: {
      "scroll": _vm.onActivityScroll
    }
  }, [_vm._l((_vm.activityGroups), function(g) {
    return _c('div', {
      key: g.day,
      staticClass: "disk-activity-day"
    }, [_c('div', {
      staticClass: "disk-activity-day-label"
    }, [_vm._v(_vm._s(g.label))]), _vm._v(" "), _vm._l((g.items), function(item) {
      return _c('div', {
        key: item.id,
        staticClass: "disk-activity-card"
      }, [_c('div', {
        staticClass: "disk-activity-dot"
      }), _vm._v(" "), _c('div', {
        staticClass: "disk-activity-card-main"
      }, [_c('div', {
        staticClass: "disk-activity-card-top"
      }, [_c('strong', [_vm._v(_vm._s(item.actorName || '成员'))]), _vm._v(" "), _c('span', {
        staticClass: "disk-activity-time"
      }, [_vm._v(_vm._s(_vm.formatActivityTime(item.gmtCreate)))])]), _vm._v(" "), _c('div', {
        staticClass: "disk-activity-summary"
      }, [_vm._v(_vm._s(item.summary))])])])
    })], 2)
  }), _vm._v(" "), (_vm.activityLoading) ? _c('div', {
    staticClass: "disk-activity-empty"
  }, [_vm._v("加载中…")]) : (_vm.activityNoMore && _vm.activityList.length) ? _c('div', {
    staticClass: "disk-activity-empty"
  }, [_vm._v("没有更多了")]) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "disk-task-float",
    class: {
      open: _vm.taskPanelOpen
    }
  }, [(_vm.taskPanelOpen) ? _c('div', {
    staticClass: "disk-task-panel"
  }, [_c('div', {
    staticClass: "disk-task-head"
  }, [_c('span', [_vm._v("任务列表")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.taskPanelOpen = false
      }
    }
  }, [_vm._v("收起")])]), _vm._v(" "), (_vm.showTaskOverall) ? _c('div', {
    staticClass: "disk-task-overall"
  }, [_c('Progress', {
    attrs: {
      "percent": _vm.taskOverallPercent,
      "stroke-width": 8
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "disk-task-overall-text"
  }, [_vm._v("\n          已传 " + _vm._s(_vm.formatSize(_vm.taskOverallDone)) + " / 共 " + _vm._s(_vm.formatSize(_vm.taskOverallTotal)) + "（" + _vm._s(_vm.taskOverallPercent) + "%）\n          "), _c('span', {
    staticClass: "disk-task-speed"
  }, [_vm._v(_vm._s(_vm.formatSpeed(_vm.taskSpeedBps)))])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "disk-task-note"
  }, [_vm._v("刷新或关闭浏览器会取消当前上传任务，并清除全部记录。")]), _vm._v(" "), _c('div', {
    staticClass: "disk-task-filters"
  }, _vm._l((_vm.taskTabs), function(tab) {
    return _c('a', {
      key: tab.key,
      class: {
        on: _vm.taskFilter === tab.key
      },
      on: {
        "click": function($event) {
          _vm.taskFilter = tab.key
        }
      }
    }, [_vm._v(_vm._s(tab.label) + "(" + _vm._s(tab.count) + ")")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "disk-task-tools"
  }, [_c('span', {
    staticClass: "disk-task-concurrency"
  }, [_vm._v("\n          并发：智能\n          "), (_vm.uploadAutoHint) ? _c('span', {
    staticClass: "disk-upload-auto-hint"
  }, [_vm._v(_vm._s(_vm.uploadAutoHint))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "disk-task-tool-btns"
  }, [_c('Button', {
    attrs: {
      "size": "small",
      "disabled": !_vm.taskUploadingCount
    },
    on: {
      "click": _vm.stopUploads
    }
  }, [_vm._v("停止上传")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "size": "small",
      "disabled": !_vm.taskResumableCount || _vm.uploading
    },
    on: {
      "click": _vm.startAllUploads
    }
  }, [_vm._v("全部开始")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "size": "small",
      "disabled": !_vm.taskRemovableCount
    },
    on: {
      "click": _vm.clearAllTasks
    }
  }, [_vm._v("全部移除")])], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), (!_vm.taskView.length) ? _c('div', {
    staticClass: "disk-task-empty"
  }, [_vm._v("暂无上传任务")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.taskView), function(item) {
    return _c('div', {
      key: item.key,
      staticClass: "disk-task-row"
    }, [_c('div', [_c('div', {
      staticClass: "disk-task-name",
      attrs: {
        "title": item.name
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "disk-task-size"
    }, [_vm._v(_vm._s(_vm.formatSize(item.size)))]), _vm._v(" "), (_vm.taskFilter === 'uploading' && item.state === 'uploading') ? _c('Progress', {
      attrs: {
        "percent": item.percent,
        "stroke-width": 6
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "disk-task-dest",
      attrs: {
        "title": item.dest
      }
    }, [_vm._v(_vm._s(item.dest || '/'))]), _vm._v(" "), _c('div', {
      class: ['disk-task-state', item.state],
      attrs: {
        "title": item.failMsg || item.stateLabel
      }
    }, [_vm._v(_vm._s(item.stateLabel))]), _vm._v(" "), _c('div', {
      staticClass: "disk-task-ops"
    }, [(item.state === 'uploading') ? _c('a', {
      on: {
        "click": function($event) {
          return _vm.pauseUpload(item)
        }
      }
    }, [_vm._v("暂停")]) : _vm._e(), _vm._v(" "), (item.state === 'stopped' || item.state === 'failed') ? _c('a', {
      on: {
        "click": function($event) {
          return _vm.continueUpload(item)
        }
      }
    }, [_vm._v("继续上传")]) : _vm._e(), _vm._v(" "), (item.state === 'stopped' || item.state === 'failed' || item.state === 'success') ? _c('a', {
      on: {
        "click": function($event) {
          return _vm.clearTask(item)
        }
      }
    }, [_vm._v("移除")]) : _vm._e()])])
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "disk-task-bar",
    on: {
      "click": function($event) {
        _vm.taskPanelOpen = !_vm.taskPanelOpen
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-cloud-upload"
    }
  }), _vm._v(" "), _c('span', [_vm._v("任务列表")]), _vm._v(" "), (_vm.taskBadge) ? _c('span', {
    staticClass: "disk-task-badge"
  }, [_vm._v(_vm._s(_vm.taskBadge))]) : _vm._e()], 1)]), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "新建群",
      "width": "420",
      "mask-closable": false
    },
    model: {
      value: (_vm.showCreateGroupModal),
      callback: function($$v) {
        _vm.showCreateGroupModal = $$v
      },
      expression: "showCreateGroupModal"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入群名称",
      "maxlength": 64
    },
    on: {
      "on-enter": _vm.onCreateGroup
    },
    model: {
      value: (_vm.createGroupName),
      callback: function($$v) {
        _vm.createGroupName = $$v
      },
      expression: "createGroupName"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.showCreateGroupModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.createGroupLoading
    },
    on: {
      "click": _vm.onCreateGroup
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "成员管理",
      "width": "860",
      "mask-closable": false
    },
    model: {
      value: (_vm.showMemberModal),
      callback: function($$v) {
        _vm.showMemberModal = $$v
      },
      expression: "showMemberModal"
    }
  }, [(_vm.activeGroup) ? _c('div', {
    staticClass: "disk-member-toolbar"
  }, [_c('Select', {
    staticStyle: {
      "width": "110px"
    },
    on: {
      "on-change": function($event) {
        _vm.memberForm.subjectIds = []
      }
    },
    model: {
      value: (_vm.memberForm.subjectType),
      callback: function($$v) {
        _vm.$set(_vm.memberForm, "subjectType", $$v)
      },
      expression: "memberForm.subjectType"
    }
  }, [_c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("员工")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("账号组")])], 1), _vm._v(" "), (_vm.memberForm.subjectType === 1) ? _c('Select', {
    staticStyle: {
      "width": "320px",
      "margin-left": "8px"
    },
    attrs: {
      "multiple": "",
      "filterable": "",
      "transfer": "",
      "loading": _vm.adminUserLoading,
      "placeholder": "选择员工"
    },
    model: {
      value: (_vm.memberForm.subjectIds),
      callback: function($$v) {
        _vm.$set(_vm.memberForm, "subjectIds", $$v)
      },
      expression: "memberForm.subjectIds"
    }
  }, _vm._l((_vm.adminUsers), function(user) {
    return _c('Option', {
      key: 'mu-' + user.id,
      attrs: {
        "value": user.id,
        "label": _vm.userLabel(user)
      }
    }, [_vm._v("\n          " + _vm._s(_vm.userLabel(user)) + "\n        ")])
  }), 1) : _c('Select', {
    staticStyle: {
      "width": "320px",
      "margin-left": "8px"
    },
    attrs: {
      "multiple": "",
      "filterable": "",
      "transfer": "",
      "loading": _vm.adminGroupLoading,
      "placeholder": "选择账号组"
    },
    model: {
      value: (_vm.memberForm.subjectIds),
      callback: function($$v) {
        _vm.$set(_vm.memberForm, "subjectIds", $$v)
      },
      expression: "memberForm.subjectIds"
    }
  }, _vm._l((_vm.adminGroups), function(group) {
    return _c('Option', {
      key: 'mg-' + group.id,
      attrs: {
        "value": group.id,
        "label": group.title
      }
    }, [_vm._v("\n          " + _vm._s(group.title) + "\n        ")])
  }), 1), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.memberSaving
    },
    on: {
      "click": _vm.addGroupMembers
    }
  }, [_vm._v("添加")]), _vm._v(" "), (_vm.isGroupOwner) ? _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    on: {
      "click": _vm.openRenameGroup
    }
  }, [_vm._v("改名")]) : _vm._e(), _vm._v(" "), (_vm.isGroupOwner) ? _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    on: {
      "click": _vm.openTransferGroup
    }
  }, [_vm._v("转让群主")]) : _vm._e(), _vm._v(" "), (_vm.isGroupOwner) ? _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "error"
    },
    on: {
      "click": _vm.dissolveGroup
    }
  }, [_vm._v("解散群")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('Table', {
    staticStyle: {
      "margin-top": "12px"
    },
    attrs: {
      "border": "",
      "columns": _vm.memberColumns,
      "data": _vm.memberList,
      "loading": _vm.memberLoading
    },
    on: {
      "on-expand": _vm.onMemberExpand
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.showMemberModal = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "群改名",
      "width": "420",
      "mask-closable": false
    },
    model: {
      value: (_vm.showRenameGroupModal),
      callback: function($$v) {
        _vm.showRenameGroupModal = $$v
      },
      expression: "showRenameGroupModal"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入新群名称",
      "maxlength": 64
    },
    on: {
      "on-enter": _vm.onRenameGroup
    },
    model: {
      value: (_vm.renameGroupName),
      callback: function($$v) {
        _vm.renameGroupName = $$v
      },
      expression: "renameGroupName"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.showRenameGroupModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.renameGroupLoading
    },
    on: {
      "click": _vm.onRenameGroup
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "转让群主",
      "width": "420",
      "mask-closable": false
    },
    model: {
      value: (_vm.showTransferModal),
      callback: function($$v) {
        _vm.showTransferModal = $$v
      },
      expression: "showTransferModal"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "transfer": "",
      "placeholder": "选择新群主（须已是群成员）"
    },
    model: {
      value: (_vm.transferOwnerId),
      callback: function($$v) {
        _vm.transferOwnerId = $$v
      },
      expression: "transferOwnerId"
    }
  }, _vm._l((_vm.personMembers), function(m) {
    return _c('Option', {
      key: 'tr-' + m.subjectId,
      attrs: {
        "value": m.subjectId,
        "label": m.subjectName
      }
    }, [_vm._v("\n        " + _vm._s(m.subjectName) + "（" + _vm._s(_vm.roleText(m.role)) + "）\n      ")])
  }), 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.showTransferModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.transferLoading
    },
    on: {
      "click": _vm.onTransferGroup
    }
  }, [_vm._v("确定转让")])], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "disk-task-cols"
  }, [_c('span', [_vm._v("文件")]), _vm._v(" "), _c('span', [_vm._v("上传到")]), _vm._v(" "), _c('span', [_vm._v("状态")]), _vm._v(" "), _c('span', [_vm._v("操作")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4426c574","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/disk/DiskIndex.vue
// module id = 1767
// module chunks = 8